import { useEffect } from 'react';

export const useTheme = () => {
  useEffect(() => {
    const theme = import.meta.env.VITE_THEME || 'default';
    import(`../globals.${theme}.scss`).then(() => {
      console.log(`Applied theme: ${theme}`);
    });
  }, []);
};
